import { ChangeDetectorRef, Directive, HostBinding, inject, model } from '@angular/core';
import { AlignStyle, WidthType } from '@core/services/api-clients';
import { HideableDirective } from './hideable.directive';

@Directive({
  selector: '[positionable]',
  standalone: true,
})
export class PositionableDirective extends HideableDirective {
  readonly alignStyle = model<AlignStyle | undefined>(AlignStyle.Left);
  readonly widthType = model<WidthType | undefined>(WidthType.AdjustToText);
  readonly width = model<number | undefined>(undefined);

  @HostBinding('style') get getPositionableStyle() {
    return {
      ...this.getWidthStyle(),
      ...this.getAlignStyle(),
    };
  }

  constructor(changeDetector?: ChangeDetectorRef) {
    super(changeDetector ?? inject(ChangeDetectorRef));
  }

  private getWidthStyle(): any {
    let style = {};
    const width = this.width();
    const widthValue = this.width();
    switch (this.widthType()) {
      case WidthType.Pixel:
        if (Number.isInteger(width)) style = { width: `${width}px` };
        break;
      case WidthType.Percentage:
        if (Number.isInteger(widthValue)) style = { width: `${widthValue}%` };
        break;
      case WidthType.AdjustToText:
        style = { width: 'fit-content' };
        break;
      case WidthType.AdjustToSpace:
        style = { width: '100%' };
        break;
    }
    return style;
  }

  private getAlignStyle(): any {
    let style = {};
    switch (this.alignStyle()) {
      case AlignStyle.Center:
        style = { margin: 'auto' };
        break;
      case AlignStyle.Right:
        style = { 'margin-left': 'auto' };
        break;
    }
    return style;
  }
}
